import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import {
  companiesPlansList,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { enterpriseCompaniesPlanCurrent } from '../api/constants';

type useGetEnterpriseCompaniesPlansProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetEnterpriseCompaniesPlans = ({
  setErrorText = () => { },
}: useGetEnterpriseCompaniesPlansProps) => {
  const client = useQueryClient();
  const { data: companiesPlansData, isFetching: isLoadingCompaniesData } =

    useQuery({
      queryKey: [companiesPlansList],
      queryFn: () =>

        axiosInstance
          .get(enterpriseCompaniesPlanCurrent)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
      refetchOnWindowFocus: false,
    });

  return {
    companiesPlansData,
    isLoadingCompaniesData,
  };
};
